/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";
import dateUtils from "utils/date";

const AppSettingsTable = ({ appSettings, companyURL, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (appSettings.loading) {
      return "is Loading";
    }
    if (isEmpty(appSettings.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Promotion</th>
            <th>Weight</th>
            <th>Freezed</th>
            <th>Released at</th>
            <th>Expired at</th>
            <th>Attachment Count</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {appSettings.data.map(appSetting => (
            <tr key={appSetting.id}>
              <td>{appSetting.id}</td>
              <td>{appSetting.title}</td>
              <td>{appSetting.promotion}</td>
              <td>{appSetting.weight}</td>
              <td>{appSetting.freezed ? "Yes" : "No"}</td>
              <td>{dateUtils.phpFormatToJS(appSetting.released_at)}</td>
              <td>{dateUtils.phpFormatToJS(appSetting.expired_at)}</td>
              <td>
                {appSetting.attachments ? appSetting.attachments.length : 0}
              </td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/${companyURL}/app-settings/${appSetting.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(appSetting.id)}
                    to={`/${companyURL}/app-settings/${appSetting.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};
export default AppSettingsTable;
